import { initializeApp } from 'firebase/app'
import { getAnalytics } from "firebase/analytics"
//import { getMessaging } from "firebase/messaging";
//import { getPerformance } from "firebase/performance";

export default defineNuxtPlugin(nuxtApp => {

    console.log('Firebase client plugin')
    const config = useRuntimeConfig()

    const firebaseConfig = {
        apiKey: config.public.apiKey,
        authDomain: config.public.authDomain,
        projectId: config.public.projectId,
        storageBucket: config.public.storageBucket,
        messagingSenderId: config.public.messagingSenderId,
        appId: config.public.appId
    };

    const app = initializeApp(firebaseConfig)
    //const messaging = getMessaging(app);

    const analytics = getAnalytics(app)
    //const performance = getPerformance(app)

    //nuxtApp.vueApp.provide('performance', performance)
    //nuxtApp.provide('performance', performance)

    //nuxtApp.vueApp.provide('messaging', messaging)
    //nuxtApp.provide('messaging', messaging)

    nuxtApp.vueApp.provide('analytics', analytics)
    nuxtApp.provide('analytics', analytics)
})